import { environment } from 'environments';
import { catchError, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { SnackbarType } from '@fuse/services/snackbar';
import { translate } from '@jsverse/transloco';

import { BaseService } from '../base';

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor() {
    super();
  }

  imageSrc(fileName: string, height?: string, width?: string): string {
    let url = `${environment.imageHandlerUrl}${fileName}`;

    if (height) {
      url += `&h=${height}`;
    }

    if (width) {
      url += `&w=${width}`;
    }

    return url;
  }

  uploadImage(file: File) {
    const formData = new FormData();

    formData.append('file', file);

    return this.clientService
      .postFormData<any>(`/files/picture`, formData)
      .pipe(
        catchError(() => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.image_upload_error')
          );

          return of(null);
        })
      );
  }
}
